/**
 * Used to keep track of JSON schema stored in database column orderPortalInfo.portalInfo
 */
export enum PortalInfoSchema {
  OrderDealer = 'ORDER_DEALER',
  OrderOwner = 'ORDER_OWNER',
  OrderStatus = 'ORDER_STATUS',
}
